import axios from "axios";

/**
 * @param {string} salt
 * @param {string} sucursal
 * @param {string} sucursal
 * @returns {Array} medicamentos
 */
export async function getMedicamentos(salt, sucursal) {
    try {
        const response = await axios.get(`/api/medicamentos`, {
            params: { suc: sucursal, descrip: salt },
        });
        return response.data;
    } catch (error) {
        console.error(error);
    }
}
